export default __webpack_public_path__ + "static/media/points_bar.880fda0d.png";